module.exports = __webpack_public_path__ + "m-header-logo-blue-dca67f81.png";